import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PageTitle from '../../../components/Accessibility/PageTitle';
import LoadingApp from '../../../components/LoadingApp';
import ModalFeedBack from '../../../components/ModalFeedBack';
import { GestaoDeCronicosHome } from '../../../interfaces/entities/SaudeBemEstar/GestaoDeCronicos/GestaoDeCronicosHome';
import { ItemCronogramaGC } from '../../../interfaces/entities/SaudeBemEstar/GestaoDeCronicos/ItemCronogramaGC';
import { MeuProgresso } from '../../../interfaces/entities/SaudeBemEstar/GestaoDeCronicos/MeuProgresso';
import { getCronograma, getHomeGestao, getMeuProgresso, getMeusAtendimentos } from '../../../services/SaudeBemEstar/GestaoDeCronicosService';
import { getBenef } from '../../../Store/storages/BeneficiarioStorage';
import { getDuotoneIconByIconClass } from '../../../utils/IconsUtils';
import ModalCronogramaGC from '../ModalCronogramaGC';
import GestaoDeCronicosButton from './GestaoDeCronicosButton';
import ProgressCard from './ProgressCard';
import './styles.css';

const HomeGC: React.FC = () => {

  const benefAtivo: boolean = getBenef()?.indStatusBenef || false;
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const [homeGestao, setHomeGestao] = useState<GestaoDeCronicosHome>();
  const [existsScheduleHistory, setExistsScheduleHistory] = useState<boolean>(false);
  const [cronogramaCompletoGC, setCronogramaCompletoGC] = useState<ItemCronogramaGC[]>()
  const [meuProgresso, setMeuProgresso] = useState<MeuProgresso>();
  const [modalFeedback, setModalFeedback] = useState<null | {
    icon?: 'error' | 'success' | 'warning', title?: string, textButton?: string, subTitle?: string,
    closeAction: () => void, showButtonModal: boolean, buttonAction?: () => void
  }>(null);

  const cleanedSvg = homeGestao?.imagemHome?.replace('data:image/svg;base64,', '') || '';

  const [modalCronograma, setModalCronograma] = useState<null | { closeAction: () => void }>(null);

  useEffect(() => {
    fetchMenu();
  }, []);

  const fetchMenu = async () => {
    setLoading(true);
    const response = await getHomeGestao();
    if (response?.status === 200) {
      setHomeGestao(response.data);
      await fetchGeneralProgress();
    } else {
      console.error(response);
      openModal('error', 'Erro', 'Ocorreu um erro ao consultar os itens do menu do Gestão de Crônicos ', 'Fechar',
        () => setModalFeedback(null), () => setModalFeedback(null)
      );
    }
    setLoading(false);
  }

  const fetchGeneralProgress = async () => {
    const response = await getMeuProgresso();
    if (response?.status === 200) {
      setMeuProgresso(response.data);
      fetchSchedulesHistory();
    } else {
      console.error(response);
      openModal('error', 'Erro', 'Ocorreu um erro ao consultar seu progresso do programa.', 'Fechar',
        () => setModalFeedback(null), () => setModalFeedback(null)
      );
    }
  }


  const fetchCronograma = async () => {
    setLoading(true);
    const response = await getCronograma();
    if (response?.status === 200) {
      setCronogramaCompletoGC(response.data);
    } else {
      console.error(response);
      openModal('error', 'Erro', 'Ocorreu um erro ao consultar o cronograma.', 'Fechar',
        () => setModalFeedback(null), () => setModalFeedback(null)
      );
    }
    setLoading(false);
  }

  const fetchSchedulesHistory = async () => {
    const result = await getMeusAtendimentos();
    if (result !== null) {
      setExistsScheduleHistory(result.data.listaMeusAtendimentos.length > 0);
    } else {
      setExistsScheduleHistory(false);
      console.error('Falha ao buscar agendamentos.');
    }
  };

  const viewCompleteSchedule = async () => {
    if (!cronogramaCompletoGC) {
      fetchCronograma();
    }
    openModalCronograma();
  }

  const openModal = (
    icon: 'success' | 'warning' | 'error', title: string, subTitle: string, textButton: string, closeAction: () => void, buttonAction: () => void
  ) => {
    setModalFeedback({
      icon,
      title,
      subTitle,
      textButton,
      showButtonModal: true,
      closeAction: closeAction,
      buttonAction: buttonAction
    });
  }

  const openModalCronograma = () => {
    setModalCronograma({
      closeAction: () => setModalCronograma(null),
    });
  }

  const handlePath = (menu: string) => {
    switch (menu) {
      case "CronicosGestaoMeusAtendimentosPage":
        return ((homeGestao?.isPermiteAgedameto && !existsScheduleHistory) ? '/saudeBemEstar/gestaoDeCronicos/agendar' : '/saudeBemEstar/gestaoDeCronicos/meusAgendamentos');
      case "CronicosGestaoMeuProgressoPage":
        return '/saudeBemEstar/gestaoDeCronicos';
      case "CronicosGestaoConteudosPage":
        return '/saudeBemEstar/gestaoDeCronicos/conteudos?back=s';
      case "CronicosGestaoEventosPage":
        return '/saudeBemEstar/gestaoDeCronicos/palestrasEventos?back=s';
      case "CronicosChatIndexPage":
        return '/saudeBemEstar/gestaoDeCronicos/conversaEquipe/conversas';
      case "CronicosGestaoConhecaProgramaPage":
        return '/saudeBemEstar/gestaoDeCronicos/conhecaOPrograma';
      case "CronicosGestaoManualUsuarioPage":
        return '/saudeBemEstar/gestaoDeCronicos/manualDoUsuario'
      default:
        return '';
    }
  }

  const handleClick = (component: string) => {
    if (benefAtivo) {
      const page = handlePath(component);
      navigate(page);
    } else {
      openModal('error', 'Atenção!',
        'Este plano está inativo e, portanto, não é possível utilizar este serviço. Em caso de dúvidas, entre em contato pelos nossos canais de atendimento.',
        '', () => setModalFeedback(null), () => setModalFeedback(null));
    }
  }

  return (
    <>
      <LoadingApp showLoading={loading} text={'Carregando...'} />
      <div className='feature-container'>
        <PageTitle text='Gestão de Crônicos' />
        {homeGestao?.imagemHome &&
          <img
            src={`data:image/svg+xml;base64,${cleanedSvg}`} alt={`Imagem ilustrativa tela inicial Gestão de Crônicos`}
            className='result-image'
          />
        }
        {homeGestao &&
          <>
            {(meuProgresso && homeGestao.menus.some(item => item.component === 'CronicosGestaoMeuProgressoPage')) && <ProgressCard progress={meuProgresso} viewCompleteSchedule={viewCompleteSchedule} />}
            <div 
              className="gestao-cronicos-buttons-holder" 
              aria-label="Painel de atalhos"
              role="list"
            >
              {
                homeGestao.menus.map((item, index) => {
                  return (
                    <React.Fragment key={index}>
                      {item.component !== 'CronicosGestaoMeuProgressoPage' &&
                        <GestaoDeCronicosButton
                          icon={getDuotoneIconByIconClass(item.icon)}
                          handleClick={() => handleClick(item.component)}
                          title={item.title} />
                      }
                    </React.Fragment>
                  )
                })
              }
            </div>
          </>
        }
      </div>
      <ModalFeedBack
        showModal={!!modalFeedback}
        handleShowModal={modalFeedback?.closeAction}
        title={modalFeedback?.title as string}
        subTitle={modalFeedback?.subTitle as string}
        icon={modalFeedback?.icon as 'success' | 'error' | 'warning'}
        showButtonModal={modalFeedback?.showButtonModal}
        textButton={modalFeedback?.textButton as string}
        handleButtonModal={modalFeedback?.buttonAction}
      />
      {cronogramaCompletoGC &&
        <ModalCronogramaGC
          showModal={!!modalCronograma}
          handleShowModal={modalCronograma?.closeAction}
          itensCronograma={cronogramaCompletoGC}
        />
      }
    </>
  )
}

export default HomeGC;